import { makeStyles } from 'tss-react/mui';

const drawerWidth = 260;

export const usePageContainerStyles = makeStyles()((theme) => {
  return {
    menuClosed: {
      pointerEvents: 'none',
    },
    appShell: {
      alignItems: 'stretch',
      background: '#F8FAF8',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      minHeight: '100vh',
      width: '100%',
    },
    drawerContainer: {
      width: drawerWidth,
      flexShrink: 0,
      boxSizing: 'border-box',
      display: 'flex',
      alignSelf: 'stretch',
      alignItems: 'flex-start',
      overflow: 'visible',
      opacity: 1,
      padding: theme.spacing(2.5, 2, 0),
      transition: theme.transitions.create(['width', 'opacity', 'padding'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    drawerSurface: {
      position: 'sticky',
      top: theme.spacing(11),
      width: '100%',
      borderRadius: '18px',
      backgroundColor: '#EEF2EE',
      border: '1px solid #DDE7DD',
      boxShadow: '0 10px 30px rgba(15, 23, 42, 0.08)',
      paddingBottom: theme.spacing(1),
      '& .MuiListItem-button, & .MuiListItemButton-root': {
        paddingTop: 10,
        paddingBottom: 10,
        borderRadius: '8px',
        margin: '2px 8px',
        color: 'rgba(15, 23, 42, 0.75)',
        transition: 'all 0.15s ease',
        '&:hover': {
          backgroundColor: 'rgba(15, 23, 42, 0.08)',
          color: '#0F172A',
        },
        '&.Mui-selected, &.Mui-selected:hover': {
          backgroundColor: 'rgba(13, 148, 136, 0.12)',
          color: '#0D9488',
          '& .MuiListItemIcon-root': {
            color: '#0D9488',
          },
          '& .MuiListItemIcon-root img': {
            filter:
              'brightness(0) saturate(100%) invert(42%) sepia(79%) saturate(458%) hue-rotate(127deg) brightness(93%) contrast(92%)',
          },
        },
      },
      '& .MuiListItemIcon-root': {
        color: 'rgba(15, 23, 42, 0.58)',
        minWidth: '40px',
        '& img': {
          opacity: 0.88,
          // Tint light PNG icons to a readable slate tone on the light sidebar.
          filter:
            'brightness(0) saturate(100%) invert(25%) sepia(13%) saturate(665%) hue-rotate(183deg) brightness(91%) contrast(88%)',
        },
      },
      '& .MuiListItemText-primary': {
        fontFamily: '"DM Sans", sans-serif',
        fontSize: '0.9rem',
        fontWeight: 500,
        color: 'inherit',
      },
      '& svg': {
        fontSize: 22,
        color: 'rgba(15, 23, 42, 0.58)',
      },
      '& .MuiDivider-root': {
        margin: '0.75rem 1rem',
        borderColor: 'rgba(15, 23, 42, 0.12)',
      },
    },
    drawerContainerClosed: {
      width: 0,
      minWidth: 0,
      paddingLeft: 0,
      paddingRight: 0,
      opacity: 0,
      overflow: 'hidden',
      pointerEvents: 'none',
    },
    content: {
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(3),
        paddingTop: theme.spacing(8),
        // Mobile bottom nav is 70px fixed — leave room so content isn't covered
        paddingBottom: theme.spacing(14),
      },
      [theme.breakpoints.down('md')]: {
        paddingBottom: theme.spacing(14),
      },
      flexGrow: 1,
      minWidth: 0,
      padding: theme.spacing(5),
      paddingTop: theme.spacing(10),
      boxSizing: 'border-box',
      maxWidth: '100%',
      width: '100%',
      background: '#F8FAF8',
    },
    signUpContainer: {
      '.MuiTypography-h1': {
        fontSize: '1.88rem',
        fontWeight: 800,
        fontFamily: '"Outfit", "DM Sans", sans-serif',
        color: '#FFFFFF',
      },
    },
    avatar: {
      textTransform: 'uppercase',
    },
    logAction: {
      background: 'linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)',
      marginBottom: 10,
      marginTop: 5,
      marginLeft: 10,
      marginRight: 10,
      borderRadius: '10px',
      width: 'auto',
      '& span': {
        color: '#FFFFFF',
        fontWeight: 600,
        fontFamily: '"Outfit", "DM Sans", sans-serif',
      },
      '& img': {
        fontSize: 22,
        filter: 'brightness(10)',
      },
      '&:hover': {
        background: 'linear-gradient(135deg, #0F766E 0%, #0D9488 100%)',
      },
    },
    skip_button: {
      position: 'absolute',
      background: '#0D9488',
      color: '#FFFFFF',
      textDecoration: 'none',
      borderRadius: '8px',
      padding: '0.5em 1em',
      margin: '0.25em',
      fontWeight: 600,
      transform: 'translateY(-150%)',
      transition: 'transform 0.3s',
      '&:focus': {
        transform: 'translateY(0%)',
        zIndex: '2000',
      },
    },

    // Mobile Menu Styling

    mobileNav: {
      display: 'flex',
      minHeight: '70px',
      width: '100%',
      padding: '0 8px',
      zIndex: '2',
      background: '#FFFFFF',

      '> *': {
        flexGrow: '1',
        flexBasis: '0',
        minWidth: '0',
        justifyContent: 'center',
      },

      '.MuiListItemButton-root': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        color: '#64748B',
        borderRadius: '0',
        margin: '0',
        '&:hover': {
          backgroundColor: 'transparent',
          color: '#0D9488',
        },
        '&.Mui-selected, &.Mui-selected:hover': {
          backgroundColor: 'transparent',
          color: '#0D9488',
          '& .MuiListItemIcon-root img': {
            filter:
              'brightness(0) saturate(100%) invert(42%) sepia(79%) saturate(458%) hue-rotate(127deg) brightness(93%) contrast(92%)',
          },
        },
      },
      '.MuiListItemIcon-root': {
        justifyContent: 'center',
        alignItems: 'center',
        height: '28px',
        minWidth: 0,
        color: 'inherit',
        '& img': {
          width: '1.3rem',
          height: '1.3rem',
          opacity: 1,
          filter:
            'brightness(0) saturate(100%) invert(42%) sepia(16%) saturate(525%) hue-rotate(178deg) brightness(93%) contrast(88%)',
        },
        '& svg': {
          fontSize: '1.5rem',
        },
      },
      '.MuiListItemText-primary': {
        fontSize: '0.7rem',
        fontWeight: 600,
      },
    },
    drawerClose: {
      position: 'absolute',
      top: '16px',
      right: '8px',
      color: '#64748B',
    },
    moreDrawer: {
      width: '300px',
      padding: '60px 20px 20px 20px',
      position: 'relative',
      background: '#FFFFFF',

      '.MuiList-root': {
        borderBottom: '1px solid #E2E8F0',
        marginBottom: '20px',
      },
      '.MuiListItem-root a': {
        paddingLeft: '0',
        paddingRight: '0',
        color: '#0F172A',
      },
    },
    menuButton: {
      display: 'flex-inline',
      flexDirection: 'column',
      flexGrow: '1',
      flexBasis: '0',
      alignItems: 'center',
      fontSize: '0.7rem',
      fontWeight: 600,
      padding: '0',
      borderRadius: '0',
      margin: '0',
      color: '#64748B',
      'span': {
        margin: '4px 0',
      },

      '.MuiSvgIcon-root': {
        height: '28px',
        color: '#64748B',
      },

      '&:hover, &:focus': {
        borderRadius: '0',
        color: '#0D9488',
      },
    },
    logActionMobile: {
      flexGrow: '0',
      minWidth: 'auto',
      background: 'linear-gradient(135deg, #0D9488 0%, #14B8A6 100%)',
      borderRadius: '99em',
      marginTop: '-18px',
      alignSelf: 'flex-start',
      height: '62px',
      width: '62px',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '4px solid #FFFFFF',
      boxShadow: '0 10px 22px rgba(13,148,136,0.35)',

      '&:hover': {
        background: 'linear-gradient(135deg, #0F766E 0%, #0D9488 100%)',
      },

      '.MuiListItemIcon-root': {
        height: '100%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        minWidth: 0,
        color: '#FFFFFF',
        '& svg': {
          fontSize: '2rem',
          color: '#FFFFFF',
        },
      },
      '.MuiListItemText-root': {
        display: 'none',
      },
    },
    logOut: {
      paddingLeft: '0',
      paddingRight: '0',
      color: '#DC2626',
      'span': {
        marginRight: '10px',
      },
    },
  };
});
